// Assign complete connected grains so powder triangles never span moving pieces.
export function bindStickyVertices(geometry,centers){
  if(!centers.length||centers.length>256)throw new RangeError('Expected 1–256 piece centers');
  const position=geometry.getAttribute('position'),index=geometry.getIndex();
  const count=position.count,parent=Uint32Array.from({length:count},(_,i)=>i);
  const find=i=>{
    while(parent[i]!==i){parent[i]=parent[parent[i]];i=parent[i];}
    return i;
  };
  const join=(a,b)=>{a=find(a);b=find(b);if(a!==b)parent[b]=a;};
  // Non-indexed triangles duplicate shared corners; indexed meshes already
  // encode connectivity and may contain intentionally separate touching grains.
  if(!index){
    const corners=new Map();
    for(let i=0;i<count;i++){
      const key=`${position.getX(i)},${position.getY(i)},${position.getZ(i)}`;
      if(corners.has(key))join(i,corners.get(key));else corners.set(key,i);
    }
  }
  const triangleCount=index?index.count:count;
  for(let i=0;i+2<triangleCount;i+=3){
    const a=index?index.getX(i):i;
    join(a,index?index.getX(i+1):i+1);
    join(a,index?index.getX(i+2):i+2);
  }
  const components=new Map();
  for(let i=0;i<count;i++){
    const root=find(i);
    let component=components.get(root);
    if(!component){component=[0,0,0,0];components.set(root,component);}
    component[0]+=position.getX(i);component[1]+=position.getY(i);component[2]+=position.getZ(i);component[3]++;
  }
  const owners=new Map();
  for(const [root,component] of components){
    const x=component[0]/component[3],y=component[1]/component[3],z=component[2]/component[3];
    let nearest=0,distance=Infinity;
    for(let i=0;i<centers.length;i++){
      const center=centers[i],d=(x-center[0])**2+(y-center[1])**2+(z-center[2])**2;
      if(d<distance){nearest=i;distance=d;}
    }
    owners.set(root,nearest);
  }
  const result=new Uint8Array(count);
  for(let i=0;i<count;i++)result[i]=owners.get(find(i));
  return result;
}
